import React from 'react';
import { Card, Col, Row } from 'antd';
import SEO from '../seo';
import { PAGE_SEO, COMMON_KEYWORDS } from '../seo/pageSeo';

function Products() {
  const products = [
    { name: 'X5 铺布机', description: '高效率铺布机，适用于各种面料。', imageUrl: 'https://via.placeholder.com/100' },
    { name: 'X6 铺布机', description: '智能控制，精确布料处理。', imageUrl: 'https://via.placeholder.com/100' },
    { name: '子母机', description: '创新设计，满足高强度工业需求。', imageUrl: 'https://via.placeholder.com/100' }
  ];

  return (
    <>
    <SEO
        pageKey="products"
        title={PAGE_SEO.products.title}
        description={PAGE_SEO.products.description}
        keywords={COMMON_KEYWORDS}
        slug={PAGE_SEO.products.slug}
    />
    <Row gutter={16}>
      {products.map((product, index) => (
        <Col key={index} xs={24} sm={12} md={8}>
          <Card
            hoverable
            cover={<img alt={product.name} src={product.imageUrl} />}
          >
            <Card.Meta title={product.name} description={product.description} />
          </Card>
        </Col>
      ))}
    </Row>
    </>
  );
}

export default Products;
